import { createSlice } from "@reduxjs/toolkit";
import jwtDecode from "jwt-decode";
import ScreenRouteEnum from "features/Enums/ScreenEnum";
const initialState = {
  isAuthenticated: false,
  forgotPasswordState: null,
  validateTokenResponseState: null,
  setPasswordState: null,
  loader: false,
  userRole: [],
  userBranches: [],
  userAccess: [],
  defaultBranch: null,
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    login(state) {
      state.loader = true;
    },
    loginSuccess(state, action) {
      state.loader = false;
      state.isAuthenticated = !!action.payload.token;
      const selectedBranch = localStorage.getItem("selectedBranch");
      const lastVisitedPath = localStorage.getItem("lastVisitedPath");
      state.token = JSON.stringify(action.payload.token);
      localStorage.setItem("isAuthenticated", state.isAuthenticated);
      localStorage.setItem("token", state.token);
      localStorage.setItem("token_bearer", action.payload.token);
      localStorage.setItem("token_type", action.payload.token_Type);
      localStorage.setItem("defaultBranch", action.payload.defaultBranch);
      localStorage.setItem(
        "selectedBranch",
        selectedBranch || action.payload.defaultBranch
      );
      if (lastVisitedPath) {
        localStorage.setItem("lastVisitedPath", lastVisitedPath);
      }
      localStorage.setItem(
        "user_Access",
        JSON.stringify(action.payload.userAccess)
      );

      const parsedAccess = action.payload.userAccess;
      const defaultBranchId = selectedBranch || action.payload.defaultBranch;
      const accessInSelectedBranch = parsedAccess?.filter(
        (a) => a.branchId === parseInt(defaultBranchId)
      );
      if (accessInSelectedBranch?.length > 0) {
        const scheduleAccess = accessInSelectedBranch?.find(
          (a) => a.screenId === ScreenRouteEnum.Schedule.id
        );
        if (scheduleAccess) {
          localStorage.setItem("defaultScreen", ScreenRouteEnum.Schedule.name);
        } else {
          const availableScreen = Object.values(ScreenRouteEnum).find(
            (scr) => scr.id == accessInSelectedBranch[0]?.screenId
          );
          localStorage.setItem("defaultScreen", availableScreen.name);
        }
      } else {
        localStorage.setItem("defaultScreen", "schedule");
      }

      localStorage.setItem(
        "user_Branches",
        JSON.stringify(action.payload.userBranches)
      );

      localStorage.setItem(
        "user_Roles",
        JSON.stringify(action.payload.userRoles)
      );
      const decoded = jwtDecode(action.payload.token);
      if (decoded) {
        state.user = JSON.stringify(decoded);
        localStorage.setItem("user", JSON.stringify(decoded));
        localStorage.setItem("userName", decoded.displayname);
        localStorage.setItem("userId", decoded.employeeid);
      }
      if (action.payload.roles) {
        state.roles = action.payload.roles;
        localStorage.setItem("roles", action.payload.roles);
      }
    },
    loginFailure(state) {
      state.loader = false;
      state.isAuthenticated = false;
    },
    loginSessionAvailable(state) {
      let token = localStorage.getItem("token");
      let token_type = localStorage.getItem("token_type");
      let token_bearer = localStorage.getItem("token_bearer");
      if (token && token_type && token_bearer) {
        const decoded = jwtDecode(token);
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        if (date === undefined || !(date.valueOf() > new Date().valueOf())) {
          state.isAuthenticated = false;
        } else {
          state.isAuthenticated = true;
        }
      } else {
        state.isAuthenticated = false;
      }
    },

    forgotPasswordSuccess(state, action) {
      state.forgotPasswordState = action.payload;
    },
    forgotPasswordFailure(state, action) {
      state.forgotPasswordState = action.payload;
    },
    resetForgotPasswordState(state) {
      state.forgotPasswordState = null;
    },
    validateTokenResponse(state, action) {
      state.validateTokenResponseState = action.payload;
    },
    setPasswordSuccess(state, action) {
      state.setPasswordState = action.payload;
    },
    setDefaultBranch(state, action) {
      state.defaultBranch = action.payload;
    },
  },
});

export const {
  login,
  loginSuccess,
  loginFailure,
  loginSessionAvailable,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  validateTokenResponse,
  setPasswordSuccess,
  setDefaultBranch,
  resetForgotPasswordState,
} = authenticationSlice.actions;
export default authenticationSlice.reducer;
